import PropTypes from 'prop-types';
import PreCall from '../vonage/device_settings/PreCall';
import { sharedDeviceMessage } from '../vonage/device_settings/messages';

const PractitionerVonagePreCall = ({
  appointment,
  user,
  locale,
  onComplete,
  onCancel,
}) => (
  <PreCall
    appointment={appointment}
    user={user}
    t={(id, values) => sharedDeviceMessage(id, locale, values) || ''}
    onComplete={onComplete}
    onCancel={onCancel}
    audience="practitioner"
    footerVariant="practitioner"
    deviceOrder={['camera', 'microphone', 'speaker']}
  />
);

PractitionerVonagePreCall.propTypes = {
  appointment: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default PractitionerVonagePreCall;
